import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import React, { useRef } from 'react';
import { useEnvironmentServiceContext } from './common/v2/context/contexts';
import { useAuthenticatedUser } from './common/v2/guards/hooks';
import { useNewVersionSnackbar } from './hooks/useNewVersionSnackbar';
import { useOfflineSnackbar } from './hooks/useOfflineSnackbar';
import { PrivateRoutes } from './private-routes/PrivateRoutes';
import { PublicRoutes } from './public-routes/PublicRoutes';

export const Routes = () => {
  const environmentService = useEnvironmentServiceContext();
  const authUser = useAuthenticatedUser();
  // Use a ref to track if components are mounted to prevent unnecessary re-renders
  const privateRoutesRef = useRef<HTMLDivElement>(null);
  const publicRoutesRef = useRef<HTMLDivElement>(null);

  useOfflineSnackbar();
  useNewVersionSnackbar();

  // Instead of conditionally rendering different component trees,
  // render both but control their visibility
  const isAuthenticated = authUser !== null;

  return (
    <>
      {/* Always render both components, but only show the appropriate one */}
      <div
        ref={privateRoutesRef}
        style={{ display: isAuthenticated ? 'block' : 'none' }}
      >
        {isAuthenticated && <PrivateRoutes />}
      </div>
      <div
        ref={publicRoutesRef}
        style={{ display: isAuthenticated ? 'none' : 'block' }}
      >
        {!isAuthenticated && <PublicRoutes />}
      </div>
      {environmentService.isLocalhost && (
        <ReactQueryDevtools
          initialIsOpen={false}
          buttonPosition="bottom-left"
        />
      )}
    </>
  );
};

Routes.displayName = 'Routes';
